import { Link } from "react-router-dom";

function ConnectWithus({ instagramShareUrl, facebookShareUrl }) {
  return (
    <>
      <div className="track_social">
        <div className="track-flex-social">
          Connect With Us :
          <Link
            to={instagramShareUrl}
            target="_blank"
            rel="noopener noreferrer"
            style={{ color: "#000" }}
          >
            <i className="bi bi-instagram"></i>
          </Link>

          <Link
            to={facebookShareUrl}
            target="_blank"
            rel="noopener noreferrer"
          >
            <i className="bi bi-facebook"></i>
          </Link>
        </div>
      </div>
    </>
  )
}
export default ConnectWithus;